export enum ItemType {
  DROPDOWN,
  NAVLINK,
}

export interface DropdownItem {
  type: ItemType.DROPDOWN;
  text: string;
  isActive?: boolean;
  width?: number;
  dataTestId?: string;
  options: NavigationItem[];
  className?: string;
  to?: string;
}

export interface NavLinkItem {
  type: ItemType.NAVLINK;
  text: string;
  isActive?: boolean;
  width?: number;
  dataTestId?: string;
  to: string;
  isExternal?: boolean;
  className?: string;
}

export type NavigationItem = DropdownItem | NavLinkItem;
